import RouteDetailModalV2 from '../components/RouteDetailModalV2.vue';
import Vue from 'vue';
const routeDetailModalV2Handler = (idRoute, events) => {

  const SidebarClass = Vue.extend(RouteDetailModalV2);
  const instance = new SidebarClass({
    propsData: { idRoute, events }
  });

  instance.$mount(); // Crea el elemento
  document.body.appendChild(instance.$el); // Lo agrega al DOM

  instance.show(); // Muestra el sidebar
};
export default routeDetailModalV2Handler;
